/**
 * @description Credentials for security reasons were kept away and for multi uses
 */

// forsquare client id and secret
export const CLIENT_ID = 'O4GXNLX01UN1HCZYIM4CVOQL4PRLN2QSJRAG1UXV30Y4T5VV';
export const CLIENT_SECRET = 'AL1B4WTAEZKORNHEIC4USTNHMWAPG14GF1DVCYZYIRB5FUGS';

// google maps key
export const MAP_KEY = 'AIzaSyAgENFZrNrnulUudDNN3IQcfjKWgMgU4q0';



// WEBPACK FOOTER //
// ./src/credentials/Credentials.js